import React from 'react'
import url from 'libraries/front-end-core/core/url'
import { ACCOUNT } from 'constants/controllers'
import { ACCOUNT_PREFERENCES } from 'constants/account-menu'
import EmailIcon from '@mui/icons-material/Email'
import { useSelector } from 'react-redux'
import selectIsLogged from 'redux/selectors/selectIsLogged'

const Title = ({ aol, short }) => (
  <section className='w-100 ph6 pt4 pb5 flex justify-between bb-thick b--dark-cerulean items-center'>
    <ToggleText display={!short} />
    <PreferenceLink aol={aol} />
  </section>
)

const PreferenceLink = ({ aol }) => {
  if (!ACCOUNT_PREFERENCES.visible) {
    return null
  }

  const isLogged = useSelector(selectIsLogged)

  return (
    <a
      className='cadet-blue f7 flex items-center no-underline hover-underline'
      href={url(ACCOUNT, { view: ACCOUNT_PREFERENCES.view })}
      data-event-category='Current Awareness'
      data-event-action='Go to account preferences'
      data-event-aol={aol}
    >
      {isLogged &&
        <span className='mr4'>
          Update your email preferences
        </span>}
      <EmailIcon />
    </a>
  )
}

const ToggleText = ({ display }) => !display
  ? null
  : (
    <span className='b f3'>
      News
    </span>
    )

export default Title
